import useOtp from './otpHook';
import { Button, Divider, Form, Input } from 'antd';
import parse from 'html-react-parser';
import { ArrowLeftOutlined, CheckCircleFilled } from '@ant-design/icons';
import PropTypes from 'prop-types';
import { QUESTION_TYPE } from '../Question';

export default function LastBtn({
    refId,
    part,
    previousStep,
    color,
    justPreview,
    currentStep,
    setIsSubmited,
}) {
    const form = Form.useFormInstance();
    const isHaveOtp = part?.groupQuestion?.some(
        (question) => question.answerType === QUESTION_TYPE.OTP
    );

    const [otpForm] = Form.useForm();

    const {
        getOtp,
        verifyOtp,
        disableOtp,
        count,
        isRequireOtp,
        refCode,
        isValidOtp,
        disabledEmail,
        lang,
    } = useOtp({ form: otpForm, justPreview, refId });

    const help =
        lang === 'th'
            ? `<span className="text-blue-100">กรุณาตรวจสอบอีเมลของท่าน หากไม่ได้รับรหัส สามารถขอรับรหัสใหม่ต้องรอ <span className="text-black font-semibold">${count}</span> วินาที \nโปรดระบุรหัส OTP ที่ได้รับ ภายในเวลา 5 นาที</span>`
            : `<span className="text-blue-100">Please check your email. If you do not receive the code, you can request a new code. You have to wait <span className="text-black font-semibold">${count}</span> seconds \nPlease enter the OTP code received within 5 minutes</span>`;

    const required_sign = <span className="required_sign">*</span>;

    const isDisabled = isHaveOtp && !isValidOtp;
    const nextStep = () => {
        if (justPreview) {
            setIsSubmited(true);
            return;
        }
        if (!isDisabled) {
            form.submit();
        }
    };

    return (
        <>
            {isHaveOtp && (
                <Form form={otpForm} className="font-semibold space-y-4">
                    <div>
                        <Form.Item
                            label={
                                lang === 'th' ? (
                                    <span>อีเมล {required_sign}</span>
                                ) : (
                                    <span>Email {required_sign}</span>
                                )
                            }
                            extra={isRequireOtp && parse(help)}
                        >
                            <div className="flex flex-col md:flex-row gap-2">
                                <Form.Item
                                    name="email"
                                    rules={[
                                        {
                                            required: true,
                                            message:
                                                lang === 'en'
                                                    ? 'This field is required.'
                                                    : 'กรุณากรอกข้อมูลให้ครบถ้วน',
                                        },
                                        {
                                            type: 'email',
                                            message:
                                                lang === 'en'
                                                    ? 'Please enter a valid email address.'
                                                    : 'รูปแบบอีเมลไม่ถูกต้อง',
                                        },
                                    ]}
                                    noStyle
                                >
                                    <Input
                                        disabled={justPreview || isValidOtp}
                                        className="w-full md:w-72"
                                        size="large"
                                        placeholder={
                                            lang === 'th'
                                                ? 'ระบุอีเมลเพื่อรับ OTP'
                                                : 'Enter your email to receive OTP.'
                                        }
                                    />
                                </Form.Item>
                                <Button
                                    disabled={disabledEmail}
                                    type="primary"
                                    size="large"
                                    className="button-link"
                                    onClick={getOtp}
                                >
                                    {lang === 'th' ? 'รับรหัส' : 'Get OTP'}
                                </Button>
                            </div>
                        </Form.Item>
                    </div>
                    <div>
                        <Form.Item
                            label={
                                lang === 'th' ? (
                                    <span>
                                        ป้อนรหัส OTP ที่ส่งไปยังอีเมล{' '}
                                        {required_sign}{' '}
                                        {refCode && `(รหัสอ้างอิง: ${refCode})`}
                                    </span>
                                ) : (
                                    <span>
                                        Enter the OTP sent to your email{' '}
                                        {required_sign}{' '}
                                        {refCode &&
                                            `(Reference code: ${refCode})`}
                                    </span>
                                )
                            }
                            extra={
                                isValidOtp && (
                                    <span className="text-green-400 flex items-center gap-2">
                                        <CheckCircleFilled />{' '}
                                        {lang === 'th'
                                            ? 'ยืนยันรหัส OTP ถูกต้อง'
                                            : 'Confirm OTP is correct'}
                                    </span>
                                )
                            }
                        >
                            <div className="flex flex-col md:flex-row gap-2">
                                <Form.Item
                                    name="otp"
                                    rules={[
                                        {
                                            required: true,
                                            message:
                                                lang === 'en'
                                                    ? 'This field is required.'
                                                    : 'กรุณากรอกข้อมูลให้ครบถ้วน',
                                        },
                                        {
                                            pattern: /^\d*$/,
                                            message:
                                                lang === 'en'
                                                    ? 'Please enter only numbers.'
                                                    : 'กรุณากรอกเฉพาะตัวเลขเท่านั้น',
                                        },
                                        {
                                            max: 6,
                                            message:
                                                lang === 'en'
                                                    ? 'Please enter 6 digits.'
                                                    : 'โปรดกรอกตัวเลขอย่างน้อย 6 หลัก',
                                        },
                                        {
                                            min: 6,
                                            message:
                                                lang === 'en'
                                                    ? 'Please enter 6 digits.'
                                                    : 'โปรดกรอกตัวเลขอย่างน้อย 6 หลัก',
                                        },
                                    ]}
                                    noStyle
                                >
                                    <Input
                                        className="w-full md:w-72"
                                        disabled={disableOtp || isValidOtp}
                                        size="large"
                                    />
                                </Form.Item>
                                <Button
                                    disabled={disableOtp || isValidOtp}
                                    type="primary"
                                    size="large"
                                    className="button-link"
                                    onClick={verifyOtp}
                                >
                                    {lang === 'th'
                                        ? 'ยืนยัน OTP'
                                        : 'Confirm OTP'}
                                </Button>
                            </div>
                        </Form.Item>
                    </div>
                </Form>
            )}
            <Divider />
            <div className="flex justify-between items-center">
                {currentStep !== 1 ? (
                    <Button
                        htmlType="button"
                        onClick={previousStep}
                        size="large"
                        type="default"
                        style={{
                            borderColor: color,
                            color,
                        }}
                    >
                        <ArrowLeftOutlined />
                        <span>Previous</span>
                    </Button>
                ) : (
                    <div />
                )}
                <Button
                    htmlType="button"
                    onClick={nextStep}
                    size="large"
                    type="primary"
                    style={{
                        backgroundColor: color,
                        borderColor: color,
                    }}
                    className="disabled:opacity-50 disabled:text-white disabled:hover:text-white"
                >
                    Submit
                </Button>
            </div>
        </>
    );
}

// Validate props
LastBtn.propTypes = {
    refId: PropTypes.string,
    part: PropTypes.object,
    previousStep: PropTypes.func,
    color: PropTypes.string,
    justPreview: PropTypes.bool,
    currentStep: PropTypes.bool,
    setIsSubmited: PropTypes.func,
};
